export default {
  capitalize(str) {
    // return str[0].toUpperCase() + str.slice(1);
    return window._.capitalize(str);
  },
};

export function toEnThObject(str) {
  return {
    en: str,
    th: str,
  };
}

export function srcToBase64(src) {
  return src.replace(/^data:image\/[a-z\\+]+;base64,/, '');
}
